import {Component, Inject, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ErrorPopupComponent} from '@shared-components/dialogs/error-popup/error-popup.component';
import {RetailerPaymentMethodsService} from '../../service/payment-methods.service';
import {lastValueFrom} from 'rxjs';
import {IconPopupComponent} from '@shared-components/dialogs/icon-popup/icon-popup.component';
import {ConsoleContextService} from "@security/console-context.service";

@Component({
  selector: 'app-verify-banking-details',
  templateUrl: './verify-banking-details.component.html',
  styleUrls: ['./verify-banking-details.component.scss']
})
export class VerifyBankingDetailsComponent {
  public otpForm;
  public errMessage: string | null = null;
  public loading: boolean = false;
  public email: string = '';
  public len = 0;
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  private offeringUuid: string;

  constructor(
    public dialogRef: MatDialogRef<VerifyBankingDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private context: ConsoleContextService,
    private dialogService: MatDialog,
    private paymentService: RetailerPaymentMethodsService
  ) {
    this.otpForm = this.resetForm();
    this.offeringUuid = data.offeringUuid;
  }

  ngOnInit(): void {
    this.getUserEmail();
  }

  onOtpChange(event: any): void {
    this.otpForm.get('pin')!.setValue(event);
    this.getPinAmount();
    this.len = this.otpForm.value.pin.toString().length;
  }

  public getPinAmount(): boolean {
    return this.otpForm.value.pin ? this.otpForm.value.pin.toString().length < 4 : true;
  }

  public onVerify(): void {
    this.loading = true;
    if (this.otpForm.value.pin) {
      lastValueFrom(this.paymentService.paymentMethodOtpConfirm(this.otpForm.value.pin, this.offeringUuid))
        .then(() => {
          this.loading = false;
          this.close();
        }, err => {
          this.loading = false;
          this.handleError(err);
        });
    }
  }

  close() {
    this.dialogRef.close();
  }

  public onResendOTP(): void {
    this.loading = true;
    this.errMessage = null;
    lastValueFrom(this.paymentService.createOtpRequest())
      .then(() => {
        this.loading = false;
        // show success message
        this.dialogService.open(IconPopupComponent, {
          height: '300px',
          width: '350px',
          data: {
            description: 'We have sent a One Time Pin to',
            boldDescription: this.context.currentUser!.email,
          },
        });
      }, err => {
        this.handleError(err);
      });
  }

  private getUserEmail(): void {
    this.email = this.context.currentUser!.email;
  }

  private resetForm(): FormGroup {
    return this.fb.group({
      pin: [null, Validators.required],
    });
  }

  private handleError(err: any): void {
    switch (err.status) {
      case 400:
        if ('ValidationException' === err.headers.get('error_code')) {
          this.errMessage = '' + err.headers.get('error_message');
          if (this.errMessage.includes('400 : [ValidationException: ')) {
            let newMessage = this.errMessage.replace('400 : [ValidationException:', '');
            newMessage = newMessage.replace(']', '');
            this.errMessage = newMessage;
          }
          this.otpForm.get('pin')!.setValue(null);
          this.ngOtpInputRef.setValue(null);
        }
        break;
      default:
        this.dialogService.open(ErrorPopupComponent, {
          height: '300px',
          width: '350px',
          data: {
            description: 'an unexpected error: ' + err,
          },
        });
    }
  }
}
